export default () => ({
  noticeDisplayed: false
});
